// extracted by mini-css-extract-plugin
module.exports = {"root":"ConfirmQuestions_root__MigW7","header":"ConfirmQuestions_header__1BqQ-","question":"ConfirmQuestions_question__2yQR6","buttonGroup":"ConfirmQuestions_buttonGroup__2PY-N"};